import store from '@/store'
import i18n from '@/i18n'
import { useFavicon } from '@vueuse/core'

export const guardLogin = (to, from, next) => {
  if (!localStorage.getItem('token')) {
    next({ name: 'Login' })
  } else {
    next()
  }
}

export const guardGuest = (to, from, next) => {
  if (localStorage.getItem('token') && !store.getters.isGuest) {
    next({ name: 'Home' })
  } else {
    next()
  }
}

export const guardPermission = (to, from, next) => {
  const permission = store.getters.permissions.find(item => item.name === to.meta.permission)
  if (!permission || !permission.active) {
    next({ name: 'Home' })
  } else {
    next()
  }
}

export const guardRole = (to, from, next) => {
  const role = to.meta.roles.includes(store.getters.role)
  if (!role) {
    next({ name: 'Home' })
  } else {
    next()
  }
}

export const guardRoleAndPermission = (to, from, next) => {
  const role = to.meta.roles.includes(store.getters.role)
  if (!role) {
    next({ name: 'Home' })
  } else {
    const permission = store.getters.permissions.find(item => item.name === to.meta.permission)
    if (!permission || !permission.active) {
      next({ name: 'Home' })
    } else {
      next()
    }
  }
}

export const guardGuestOnly = (to, from, next) => {
  if (!store.getters.isGuest) {
    next({ name: 'Home' })
  } else {
    next()
  }
}

const guestAllowedRoutes = [
  'GuestSettings',
  'GuestHome',
  'Register',
  'Error404',
  'Error429',
  'Error500',
  'SpedilinkOffers',
  'SpedilinkCargoOfferList',
  'SpedilinkVehicleOfferList',
  'SpedilinkUnsubscribeNotifications'
]

export const beforeEach = async (to, from, next) => {
  if (store.getters.loading) {
    await store.dispatch('initApp')
  }
  const path = typeof to.path === 'string' ? to.path : ''
  const fullPath = typeof to.fullPath === 'string' ? to.fullPath : ''
  const isSpediOffersPath = path.includes('/spedilink/offers') || fullPath.includes('/spedilink/offers')

  const hasSpedilinkPermission =
    store.getters.permissions.find(p => p.name === 'SpedilinkAccess')?.active === true
  const isSpedilinkRootPath = path === '/spedilink' || fullPath === '/spedilink'
  const isSpedilinkMyLinksPath =
    path.startsWith('/spedilink/my-links') || fullPath.startsWith('/spedilink/my-links')

  if (!store.getters.isGuest && !hasSpedilinkPermission && !isSpediOffersPath && (isSpedilinkRootPath || isSpedilinkMyLinksPath)) {
    return next({ name: 'SpedilinkOffers' })
  }

  if (store.getters.isGuest && !guestAllowedRoutes.includes(to.name) && !isSpediOffersPath) {
    return next({ name: 'GuestSettings' })
  }
  next()
}

export const afterEach = to => {
  document.title = 'Spedimo - ' + i18n.t(`documentTitle.${to.name.toLowerCase()}`) || ''

  const icon = useFavicon()
  icon.value = 'static/img/favicon.png'
}
